(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/assets/javascripts/pages/page-chat-schedule.js') >= 0) return;  svs.modules.push('/modules/bingo-react/assets/javascripts/pages/page-chat-schedule.js');
"use strict";


const {
  ChatHostScheduleSection
} = svs.bingo_react.components;
const {
  BingoChatHostCard
} = svs.bingo_react.components.bingoChatHostCard;
const {
  chatHosts
} = svs.bingo_react.data;
const {
  PageHeader
} = svs.bingo_react.components.page_header;
const BingoChatSchedule = _ref => {
  let {
    headerConfig
  } = _ref;
  return React.createElement("main", {
    className: "bingo-main-content-container f-content"
  }, React.createElement(PageHeader, {
    fallbackConfig: {
      header: 'Våra chattvärdar'
    },
    headerConfig: headerConfig
  }), React.createElement("section", {
    className: "bingo-chat-host-schedule-container"
  }, React.createElement("h3", {
    className: "h2"
  }, "Schema"), React.createElement(ChatHostScheduleSection, null)), chatHosts && React.createElement("section", null, React.createElement("h3", {
    className: "h2 bingo-chat-host-title"
  }, "L\xE4r k\xE4nna v\xE5ra chattv\xE4rdar"), React.createElement("div", {
    className: "bingo-chat-host-container"
  }, chatHosts === null || chatHosts === void 0 ? void 0 : chatHosts.map(chatHost => React.createElement(BingoChatHostCard, {
    chatHost: chatHost,
    key: chatHost.BOID
  })))));
};
setGlobal('svs.bingo_react.pages.BingoChatSchedule', BingoChatSchedule);

 })(window);